import React, { forwardRef, useImperativeHandle } from "react";
import { Modal } from "react-bootstrap";
import FontStyledContainer from "./FontContainer.styled";
import styled from "styled-components";

function AppModal({ children }, ref) {
   const [modalShow, setModalShow] = React.useState(false);
   useImperativeHandle(ref, () => ({
      setModalShow,
   }));
   const btnStyle = { position: "absolute", right: "7px", margin: "7px", top: "7px", cursor: "pointer", zIndex: "11" };
   return (
      <Modal show={modalShow} size="lg" aria-labelledby="contained-modal-title-vcenter" className="backdropClassName" onHide={() => setModalShow(false)} centered>
         <FontStyledContainer>
            <div style={{ position: "relative" }}>
               <CloseBtn onClick={() => setModalShow(false)}>Χ</CloseBtn>
               {children} 
            </div>
         </FontStyledContainer>
      </Modal>
   );
}
const CloseBtn = styled.span`
   position: absolute;
   right: 20px;
   margin: 7px;
   top: 20px;
   cursor: pointer;
   z-index: 111;
   background: white;
   width: 30px;
   height: 30px;
   display: flex;
   justify-content: center;
   align-items: center;
   border-radius: 50%;
   font-weight: 800;
`;
export default forwardRef(AppModal);
